import React, { useEffect, useState } from "react";
import { getDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../api/firebase";

const DeleteAnnounce = ({setOpen, requestId }) => {
  // ユーザ取得関連
  const [announce, setAnnounce] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // リクエスト取得
  useEffect(() => {
    // リクエストショップ取得
    if (requestId) {
      getDoc(doc(db, "notificationOfTop", requestId)).then((doSnap) => {
        if (doSnap.exists) {
          setAnnounce(doSnap.data());
        }
      });
    }
  }, [requestId]);
  //   削除処理
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 削除
      await deleteDoc(doc(db, "notificationOfTop", requestId));
      setOpen(false)
      // window.location.reload();
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };
  return (
    <>
      <div className="mb-3 bg-blue-500 text-white p-1 rounded-full text-center">
        お知らせ削除
      </div>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="font-bold text-2xl">このお知らせを削除します</div>
        <div className="border-2 p-2 rounded-md mb-2">
          <div className="text-gray-300">お知らせ</div>
          <div>{announce.title}</div>
        </div>
        <button
          data-mdb-ripple="true"
          data-mdb-ripple-color="light"
          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          disabled={loading}
          onClick={handleDelete}
        >
          {loading ? "削除しています..." : "削除"}
        </button>
      </form>
    </>
  );
};

export default DeleteAnnounce;
